export default __webpack_public_path__ + "static/media/capture-feedback.5eb60bea.svg";